import React, { useState } from 'react'
import PageHeader from '../../components/PageHeader'
import { Box, Tabs, Tab } from '@mui/material'
import CourseAttributes from './CourseAttributes'
import FacultyAttributes from './FacultyAttributes'
import StudentAttributes from './StudentAttributes'
import { ATTRIBUTE_TYPES } from '../../consts'

const AttributesFeature: React.FC = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState<string>(ATTRIBUTE_TYPES.COURSE_ATTRIBUTES)

  const handleTabChange = (event: React.SyntheticEvent, newValue: string): void => {
    setActiveTab(newValue)
  }

  return (
    <Box display='flex' flexDirection='column' gap={6}>
      <PageHeader title='Attributes' showBackButton />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="attribute types tabs"
          sx={{
            '& .MuiTab-root': {
              fontWeight: '600',
              fontSize: '14px',
              paddingLeft: 0,
              marginRight: 4
            }
          }}
        >
          <Tab label="Course" value={ATTRIBUTE_TYPES.COURSE_ATTRIBUTES} />
          <Tab label="Faculty and Staff" value={ATTRIBUTE_TYPES.FACULTY_COURSE_ATTRIBUTES} />
          <Tab label="Student" value={ATTRIBUTE_TYPES.STUDENT_COURSE_ATTRIBUTES} />
        </Tabs>
      </Box>

      {activeTab === ATTRIBUTE_TYPES.COURSE_ATTRIBUTES && <CourseAttributes />}
      {activeTab === ATTRIBUTE_TYPES.FACULTY_COURSE_ATTRIBUTES && <FacultyAttributes />}
      {activeTab === ATTRIBUTE_TYPES.STUDENT_COURSE_ATTRIBUTES && <StudentAttributes />}
    </Box>
  )
}

export default AttributesFeature
